/**
 * DOPAMEAN — Discovery Mode
 * Torch toggle that switches the collection grid between normal (4-col)
 * and compact Discovery Mode (6-col) with localStorage persistence.
 */
(function () {
  'use strict';

  var STORAGE_KEY    = 'dpm_discovery_mode_session';
  var DISCOVERY_CLS  = 'dpm-discovery-mode';
  var COLLECTION_CLS = 'dpm-is-collection';
  var BTN_ON_CLS     = 'dpm-discovery-btn--on';
  var SWITCHING_CLS  = 'dpm-discovery-switching';
  var FADE_MS        = 130; // matches CSS transition-duration

  function getBtn() {
    return document.getElementById('dpm-discovery-btn');
  }

  function getContainer() {
    return document.getElementById('ProductGridContainer');
  }

  /* Apply or remove discovery mode without any transition (used on page load) */
  function applyModeInstant(on) {
    var btn = getBtn();
    if (on) {
      document.body.classList.add(DISCOVERY_CLS);
      if (btn) {
        btn.classList.add(BTN_ON_CLS);
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('title', 'Discovery Mode ON — click to return to normal view');
      }
    } else {
      document.body.classList.remove(DISCOVERY_CLS);
      if (btn) {
        btn.classList.remove(BTN_ON_CLS);
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('title', 'Discovery Mode — see more products at once');
      }
    }
  }

  /* Toggle with a fade-out / layout-change / fade-in sequence */
  function toggleMode() {
    var btn = getBtn();
    var container = getContainer();

    // Disable button during transition to prevent double-taps
    if (btn) btn.disabled = true;

    var nextOn = !document.body.classList.contains(DISCOVERY_CLS);

    // 1. Fade out the grid container
    document.body.classList.add(SWITCHING_CLS);

    setTimeout(function () {
      // 2. Apply new layout while invisible
      applyModeInstant(nextOn);
      sessionStorage.setItem(STORAGE_KEY, nextOn ? '1' : '0');

      // 3. Fade back in on the next animation frame (after layout paint)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.body.classList.remove(SWITCHING_CLS);
          if (btn) btn.disabled = false;
        });
      });
    }, FADE_MS);
  }

  function init() {
    // Only activate on collection pages (product grid must exist)
    if (!document.getElementById('product-grid')) return;

    // Mark body so CSS can show the torch button
    document.body.classList.add(COLLECTION_CLS);

    // Restore saved mode from localStorage (no transition on load)
    var saved = sessionStorage.getItem(STORAGE_KEY);
    applyModeInstant(saved === '1');

    // Wire up button
    var btn = getBtn();
    if (btn) {
      btn.addEventListener('click', toggleMode);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialise when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
